import styled, { css } from 'styled-components';
import { themeContract } from './Pagination.theme.contract';
var buttonDimensions = 42;
var buttonActiveDimensions = 40;
var buttonMargin = 15;
var Pagination = styled.nav.withConfig({
  displayName: "Paginationstyles__Pagination",
  componentId: "sc-1temk9l-0"
})(["justify-content:center;font-size:18px;", " ", " ", ""], function (props) {
  return css(["font-family:", ";"], props.theme.font.family.brand);
}, function (props) {
  return props.position === 'right' && css(["@media screen and (min-width:", "){justify-content:flex-end;}"], props.theme.size.breakpoint['min-width'].sm);
}, function (props) {
  return props.position === 'left' && css(["@media screen and (min-width:", "){justify-content:flex-start;}"], props.theme.size.breakpoint['min-width'].sm);
});
var PageLink = styled.a.withConfig({
  displayName: "Paginationstyles__PageLink",
  componentId: "sc-1temk9l-1"
})(["cursor:pointer;align-items:center;justify-content:center;width:", "px;height:", "px;line-height:", "px;padding:0;text-align:center;border-radius:3px;margin-left:", "px;font-size:", ";border:1px solid ", ";color:", ";fill:", ";:first-child{margin-right:", "px;margin-left:0;}:nth-child(2){margin-left:0;}", " ", " ", " ", ""], buttonDimensions, buttonDimensions, buttonDimensions, buttonMargin, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, buttonMargin, function (props) {
  return props.easter && css(["transform:rotate(180deg);transition:transform 0.8s ease-in-out;:hover{transform:rotate(360deg);}"]);
}, function (props) {
  return !props.disabled && !props.active && css([":hover{background-color:", ";}"], props.theme.color.monochrome.lighter);
}, function (props) {
  return props.active && css(["border:2px solid ", ";background-color:", ";color:", ";line-height:", "px;"], props.theme.color.palette['brand-1'], props.theme.color.palette[themeContract[props.theme.channel].linkActive.backgroundColor], props.theme.color.palette['brand-1'], buttonActiveDimensions);
}, function (props) {
  return props.disabled && css(["cursor:not-allowed;svg{fill:", ";}"], props.theme.color.monochrome.light);
});
var PageNumbers = styled.span.withConfig({
  displayName: "Paginationstyles__PageNumbers",
  componentId: "sc-1temk9l-2"
})(["justify-content:center;align-items:center;width:calc(100% - 2 * (", "px + ", "px));"], buttonDimensions, buttonMargin);
export { PageLink, Pagination, PageNumbers };